<!-- Settle User Rights during the creation -->

<template>
  <section class="modal reduced">
    <div class="content">
      <div class="row spaceBetween">
        <h1>{{$t('addUser.title')}}</h1>
      </div>
    </div>
    <hr>
    <div class="content">
      <p class="accentuate">{{$t('addUser.permissions')}}</p>
      <!--Récup des profiles-->
      <div class="row" v-for="data in profiles" :key="data.title">
        <div class="row" v-if="accesToProfileDependingOfCurrentUserRights(data)">
          <input type="radio" :value="data.id" name="userProfile" v-model="profile">
          <p>{{data.name}}</p>
          <!--ajout du test sur les droits du user -->
          <p class="tips">{{data.description}}</p>
        </div>
      </div>
      <!--Profil perso-->
      <div class="row" v-if="$store.getters.USERPROFILE['user-profile-administration']">
        <!--ajout du test sur les droits du user -->
        <input type="radio" value="perso" v-model="profile">
        <p>{{$t('addUser.personnalize')}}</p>
        <p class="tips">{{$t('addUser.persoLegend')}}</p>
      </div>
      <!--Récup des infos de profils personnalisé-->
      <div class="row" v-if="profile == 'perso'">
        <input type="text" class="smallInput mL" v-model="persoUserProfile['name']">
        <p class="tips">{{$t('addUser.personnalizeTips')}}</p>
      </div>
      <div class="row" v-if="profile == 'perso'">
        <input type="text" class="smallInput mL" v-model="persoUserProfile['description']">
        <p class="tips">{{$t('addUser.personnalizeDescriptionTips')}}</p>
      </div>
 <div class="row" v-if="profile == 'perso'">
          <label class="container">
            <input
              type="checkbox"
              v-model="persoUserProfile['default-profile']"
            />
            <span class="checkmark"></span>{{$t('newProfile.defaultProfile')}}
          </label>
        </div>
        <br><br>

      
      <div class="row" v-if="profile == 'perso'">
        <div class="column">
            <div v-for="info in checkboxInfoList1" :key="info.title" class="row">
              <label class="container">
                <input
                  type="checkbox"
                  v-model="persoUserProfile[info.model]"
                />
                <span class="checkmark"></span><p style="padding-right: 25px;">{{info.value}}</p>
              </label>
              <br><br>
            </div>
          </div>
           <div class="column">
            <div v-for="info in checkboxInfoList2" :key="info.title" class="row">
              <label class="container">
                <input
                  type="checkbox"
                  v-model="persoUserProfile[info.model]"
                />
                <span class="checkmark"></span>{{info.value}}
              </label>
              <br><br>
            </div>
          </div>
      </div>
    </div>
    <hr>
    <div class="content">
      <div class="row">
        <button @click="addUserdependingProfile">{{$t('button.invite')}}</button>
        <button class="outline" @click="$emit('previous')">{{$t('button.back')}}</button>
        <a @click="$emit('close')">{{$t('button.cancel')}}</a>
      </div>
    </div>
  </section>
</template>

<script>
import getProfiles from "@/mixins/getProfiles";
export default {
  props: ["user"],
  mixins: [getProfiles],
  data() {
    return {

      profile: "",
      formStatus: {
        created: false
      }
    };
  },
  mounted() {
    this.getProfiles();
  },
  methods: {}
};
</script>
